import api from './axios';

export const diskApi = {
  // Obtener uso del disco
  getDiskUsage: () => api.get('/disk/usage'),
  
  // Obtener lista de logs
  getLogs: () => api.get('/disk/logs'),
  
  // Eliminar un log específico
  deleteLog: (logPath) => api.delete('/disk/logs', { 
    params: { log_path: logPath } 
  }),
  
  // Limpiar logs antiguos
  cleanOldLogs: (days = 30) => api.post('/disk/clean-logs', null, {
    params: { days }
  }),
  
  // Ejecutar logrotate
  runLogrotate: () => api.post('/disk/logrotate')
};
